import moment from 'moment';

export function nullIfEmpty<T>(value: T | '' | null | undefined): T | null {
  return value === '' || value === undefined || value === null ? null : value;
}

export function toISODateString(date: unknown): string | null {
  if (!date) {
    return null;
  }

  if (date instanceof Date) {
    return date.toISOString().split('T')[0];
  }

  if (moment.isMoment(date)) {
    return date.isValid() ? date.format('YYYY-MM-DD') : null;
  }

  if (typeof date === 'string') {
    const parsedDate = new Date(date);
    return Number.isNaN(parsedDate.getTime()) ? null : parsedDate.toISOString().split('T')[0];
  }

  return null;
}

export function replaceEmptyWithNullDeep<T>(value: T): T {
  if (value === undefined || value === '') {
    return null as T;
  }

  if (value === null) {
    return value;
  }

  if (Array.isArray(value)) {
    return value.map((item) => replaceEmptyWithNullDeep(item)) as T;
  }

  if (typeof value === 'object') {
    const result: Record<string, unknown> = {};

    Object.entries(value as Record<string, unknown>).forEach(([key, currentValue]) => {
      result[key] = replaceEmptyWithNullDeep(currentValue);
    });

    return result as T;
  }

  return value;
}